import React from "react";
import { SearchNormal } from "iconsax-reactjs";
import { Select } from "../../../shared/ui";
import {
  sortOptions,
  tableCurrencyOptions,
  subTabsConfig,
  typeFilterOptions,
} from "../constants/filterOptions";
import { TransactionSubTab } from "../types";

export { typeFilterOptions };


interface TransactionFiltersBarProps {
  subTab: TransactionSubTab;
  onSubTabChange: (tab: TransactionSubTab) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  sortBy: string;
  onSortChange: (sort: string) => void;
  currencyFilter: string;
  onCurrencyChange: (currency: string) => void;
  typeFilter: string;
  onTypeChange: (type: string) => void;
  onExport: () => void;
  isOtcTab?: boolean;
}

export const TransactionFiltersBar: React.FC<TransactionFiltersBarProps> = ({
  subTab,
  onSubTabChange,
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  currencyFilter,
  onCurrencyChange,
  typeFilter,
  onTypeChange,
  onExport,
  isOtcTab = false,
}) => {
  return (
    <>
      {/* Sub Tabs / Filter Pills */}
      <div className="mt-4 flex items-center gap-3 overflow-x-auto pb-1 text-[13px]">
        {subTabsConfig.map((item: {
          label: TransactionSubTab;
          count?: number;
        }) => {
          const isActive = subTab === item.label;
          return (
            <button
              key={item.label}
              type="button"
              onClick={() => onSubTabChange(item.label)}
              className={`flex shrink-0 items-center gap-1.5 transition-all ${
                isActive
                  ? "rounded-[6px] bg-[#F4F0FF] px-3.5 py-1 font-semibold text-[#6F00FF]"
                  : "px-2 py-1 font-medium text-[#475467] hover:text-[#161827]"
              }`}
            >
              <span>{item.label}</span>
              {item.count !== undefined && (
                <span className="flex h-[15px] min-w-[15px] items-center justify-center rounded-full bg-[#12B76A] px-1 text-[9px] font-bold text-white">
                  {item.count}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Action Bar matching KYB FiltersBar design pattern */}
      <div className="my-4 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-1 flex-col gap-3 lg:flex-row lg:items-center">
          {/* Search Input */}
          <div className="relative flex h-[40px] w-full items-center rounded-[8px] bg-[#F8F9FF] px-3.5 border border-[#E1E6FF]/70 lg:w-[300px]">
            <SearchNormal size={17} className="mr-2 text-[#6F739B]" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search transactions"
              className="w-full bg-transparent text-[13px] text-[#161827] outline-none placeholder:text-[#9396B4]"
            />
          </div>

          <div className="hidden h-7 w-px bg-[#EEF1FB] lg:block" />

          {/* Filter Dropdowns */}
          <div className="flex flex-wrap items-center gap-2.5">
            <Select
              value={sortBy}
              onChange={onSortChange}
              title="Sort by"
              placeholder="Recent first"
              triggerPrefix="Sort"
              options={sortOptions}
              className="h-[28px] py-0 px-3 rounded-xl text-[13px]"
              contentClassName="w-[260px]"
            />

            <Select
              value={currencyFilter}
              onChange={onCurrencyChange}
              title="Currency"
              placeholder="All"
              triggerPrefix="Currency"
              options={tableCurrencyOptions}
              className="h-[28px] py-0 px-3 rounded-xl text-[13px]"
              contentClassName="w-[250px]"
            />

            {!isOtcTab && (
              <Select
                value={typeFilter}
                onChange={onTypeChange}
                title="Type"
                placeholder="All"
                triggerPrefix="Type"
                options={typeFilterOptions}
                className="h-[28px] py-0 px-3 rounded-xl text-[13px]"
                contentClassName="w-[270px]"
              />
            )}
          </div>
        </div>

        {/* Export Button */}
        {/* <Button
          type="button"
          onClick={onExport}
          className="h-[40px] rounded-[8px] bg-[#101828] px-5 text-[14px] font-[550] text-white hover:bg-[#1f2937] flex items-center gap-2 transition-colors"
        >
          <ExportCurve size={18} />
          <span>Export</span>
        </Button> */}
      </div>
    </>
  );
};
